import React from "react";
import { motion, useReducedMotion } from "framer-motion";

type Props = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  y?: number;
  as?: "div" | "section" | "header" | "article";
  amount?: number;
};

/** Fade + slide upward — 0.4s ease as per brief, staggered via delay prop. */
export default function SectionReveal({
  children, className = "", delay = 0, y = 24, as = "div", amount = 0.2,
}: Props) {
  const reduced = useReducedMotion();
  const Comp = motion[as] as any;
  return (
    <Comp
      initial={reduced ? { opacity: 1 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.5, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
      className={className}
    >
      {children}
    </Comp>
  );
}
